'use client';
import { useManagerEntity } from '@/shared/managerHelpers';
import React from 'react';
import { useEffect, useState } from 'react';
import { IconButton } from './ui/button';
import { PiMinus, PiPlus, PiSpeedometerThin } from 'react-icons/pi';
import { Slider } from './ui/slider';

const STEP = 0.5;

const SpeedChange = ({ mode }: { mode: 'Play' | 'Practice' }) => {
  const ManagerEntity = useManagerEntity();
  const timer = ManagerEntity?.player?.timer;
  const [speed, setSpeed] = useState(10);

  useEffect(() => {
    if (timer && speed) {
      timer.speed = speed;
      console.log(`Timer speed updated to useEffect: ${speed}`, timer);
    }
  }, [speed, timer]);

  if (!ManagerEntity) {
    return null;
  }

  const handleSpeedChange = (value: number[]) => {
    setSpeed(value[0]);
  };

  return (
    <>
      {mode === 'Play' ? (
        <div className='flex items-center px-1'>
          <div className='p-1'>
            <PiSpeedometerThin size={36} />
          </div>
          <div className='flex items-center gap-2'>
            <IconButton
              onClick={() => {
                setSpeed((prev: number) => Math.max(prev - STEP, 0));
                console.log(
                  `Timer speed updated to: ${Math.max(speed - STEP, 0)}`
                );
              }}
            >
              <PiMinus size={16} />
            </IconButton>
            <div style={{ display: 'flex' }}>
              <Slider
                max={20}
                value={[speed]}
                onValueChange={(value) => handleSpeedChange(value)}
                step={STEP}
                data-testid='slider'
                className='w-24'
              />
            </div>
            <IconButton
              onClick={() => {
                setSpeed((prev: number) => Math.min(prev + STEP, 20));
              }}
            >
              <PiPlus size={16} />
            </IconButton>
          </div>
          <div className='ml-2 w-[1px] h-6 bg-zinc-200' />
        </div>
      ) : null}
    </>
  );
};

export default SpeedChange;
